import axios from "./AxiosInstance"

const getUserData = () => axios.get("api/users/me")

const getUserInfosById = (userId) => axios.get(`api/users/${userId}`)

const changePassword = ({ userId, actualPassword, retypePassword, password }) =>
    axios.put(`api/users/changePassword/${userId}`, {
        actualPassword: actualPassword,
        password: password,
        retypePassword: retypePassword
    })

const getPatientFile = (userId) => axios.get(`api/patients/${userId}/patientFile`)

const resetPassword = (payload) =>
    axios.put("api/users/resetPassword", {
        ...payload
    })
const forgotPassword = (data) => axios.put("api/users/forgotPassword", { ...data })

const updateUserData = (userId, data) => axios.put(`api/users/${userId}`, { ...data })

const getConstantTypes = () => axios.get(`api/constantVitalSignTypes`)

const getConstantsHistory = (userId) =>
    axios.get(`api/patients/${userId}/constantVitalSigns/detailsEvolution?archived=0`)

const getFreeSlot = () => axios.get(`api/freeslot?duration=60`)

const getSpecialityTypes = () => axios.get(`api/specialityTypes`)

const activateAccount = ({ token, email }) => axios.post(`api/users/activation`, { token: token, email: email })

const saveConstants = (data) => axios.post(`api/constantVitalSigns`, { ...data })

const deleteConstants = ({ patientId, constantVitalSignTypeIds }) =>
    axios.delete(`api/patients/${patientId}/constantVitalSigns`, {
        data: {
            constantVitalSignTypeIds
        }
    })

const getConstants = (userId, date) => axios.get(`api/users/${userId}/constantVitalSigns?date=${date}`)

const saveConsent = (payload) => axios.post(`api/userConsent`, payload)

const updateConsent = (payload, userId) => axios.put(`api/userConsent/${userId}`, payload)

const deleteUserAccount = () => axios.delete("api/users/me")

const getConsent = (userId) => axios.get(`api/userConsent/${userId}`)

const getNotificationToken = () => axios.get(`api/users/firebaseToken`)

const subscribeNotification = (token) => axios.post(`api/users/firebaseToken`, { firebaseToken: token })

const unsubscribeNotification = (token) => axios.delete(`api/users/firebaseToken/${token}`)

const getConstantVitalSignsList = (patientID) => axios.get(`api/users/${patientID}/constantVitalSigns?limit=1`)

const getEnteredHealthProfessionals = (patientID) =>
    axios.get(`api/enteredHealthProfessionals?patientId=${patientID}&isValidatedPatient=0`)

const getUserPrograms = (userId) => axios.get(`api/programs/patients/${userId}`)

const getProfilePicture = (userId) => axios.get(`api/users/${userId}/ImageProfil?paginated=false`)

const GetConstantById = (constantId) => axios.get(`api/constants/${constantId}`)

const DeleteConstantByIds = (patientId, patientConstants) =>
    axios.delete(`api/patient/${patientId}/constants`, {
        data: { patientConstants }
    })

export const UserService = {
    DeleteConstantByIds,
    GetConstantById,
    getProfilePicture,
    getUserPrograms,
    getConstantsHistory,
    getConstantTypes,
    getConstants,
    getUserData,
    changePassword,
    saveConsent,
    getConsent,
    updateUserData,
    saveConstants,
    forgotPassword,
    resetPassword,
    activateAccount,
    unsubscribeNotification,
    subscribeNotification,
    getNotificationToken,
    deleteUserAccount,
    getFreeSlot,
    getSpecialityTypes,
    getPatientFile,
    updateConsent,
    getConstantVitalSignsList,
    getEnteredHealthProfessionals,
    getUserInfosById,
    deleteConstants
}
